import { useEffect, type ReactElement } from "react";
import { colorTokensCss } from "./colorTokens";
import { typographyTokensCss } from "./typographyTokens";
import { motionTokensCss } from "./motionTokens";
import { applyThemePreference, getStoredThemePreference } from "../state/themePreference";

/**
 * Injects design-token CSS custom properties + typography utility classes
 * once at the app root (`RootLayout`). Every route — marketing, viewer,
 * checkout, dev catalogues — can then use:
 *
 *   var(--color-text-default)
 *   class="type-heading-title"
 *   transition: opacity var(--duration-fast) var(--ease-smooth-out)
 *
 * TypeScript access (`colorTokens`, `typographyStyle`, etc.) does not need
 * this component; import the token modules directly.
 *
 * Theme mode is controlled by `ThemePreferenceProvider` via `data-theme` on
 * `<html>`. We sync once on mount so token vars match persisted preference
 * before the first themed paint inside nested routes.
 */
export function DesignTokensStyle(): ReactElement {
  useEffect(() => {
    applyThemePreference(getStoredThemePreference());
  }, []);

  return (
    <style>{`${colorTokensCss()}\n\n${typographyTokensCss()}\n\n${motionTokensCss()}`}</style>
  );
}
